import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modeButton", "birthdayPanel", "estimatePanel", "birthdayInput", "estimateInput"]
  static values = { initialMode: String }

  connect() {
    this.mode = this.initialModeValue || "birthday"
    this.prepareSubmit = this.prepareSubmit.bind(this)
    this.element.closest("form")?.addEventListener("submit", this.prepareSubmit)
    this.show(this.mode)
  }

  disconnect() {
    this.element.closest("form")?.removeEventListener("submit", this.prepareSubmit)
  }

  select(event) {
    this.show(event.currentTarget.dataset.birthInformationMode)
  }

  show(mode) {
    this.mode = mode
    const estimating = mode === "estimate"

    this.birthdayPanelTarget.hidden = estimating
    this.estimatePanelTarget.hidden = !estimating

    this.modeButtonTargets.forEach((button) => {
      const active = button.dataset.birthInformationMode === mode
      button.setAttribute("aria-pressed", active.toString())
      button.classList.toggle("bg-white", active)
      button.classList.toggle("text-slate-900", active)
      button.classList.toggle("shadow-sm", active)
      button.classList.toggle("dark:bg-slate-600", active)
      button.classList.toggle("dark:text-white", active)
      button.classList.toggle("text-slate-500", !active)
      button.classList.toggle("hover:text-slate-700", !active)
      button.classList.toggle("dark:text-slate-400", !active)
      button.classList.toggle("dark:hover:text-slate-200", !active)
    })
  }

  prepareSubmit() {
    const estimating = this.mode === "estimate"

    if (estimating) {
      this.birthdayInputTarget.value = ""
    } else {
      this.estimateInputTargets.forEach((input) => { input.value = "" })
    }
  }
}
